import { render, staticRenderFns } from "./touchBalance.vue?vue&type=template&id=e8cc8dac&scoped=true&"
import script from "./touchBalance.vue?vue&type=script&lang=js&"
export * from "./touchBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8cc8dac",
  null
  
)

export default component.exports